<template>
    <a-drawer :title="title" width="600" :maskClosable="false" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-form-model ref="form">
            <a-form-model-item label="设备信息">
                <a-tag color="#2db7f5">
                    {{ item.sno }}
                </a-tag>
                {{ item.name }}
            </a-form-model-item>

            <a-transfer
                :data-source="ctas"
                show-search
                :titles="['员工', '已选']"
                :list-style="{
                    width: '250px',
                    height: '300px'
                }"
                :target-keys="sels"
                :render="item => `[${item.key}] ${item.title}`"
                @change="onChange"
            >
                <span slot="notFoundContent">
                    无员工数据
                </span>
            </a-transfer>

            <a-form-model-item :style="{ marginTop: '10px' }">
                <a-button type="primary" @click="doSave" icon="save">
                    提交关联设置
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </a-drawer>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            ctas: [],
            sels: [],
            field: {
                id: '',
                cids: '',
                flag: true
            }
        }
    },
    mounted() {
        this.doLoadCta()
        this.field.id = this.item.id
    },
    methods: {
        onChange(targetKeys) {
            this.sels = targetKeys
        },
        doLoadCta() {
            let cids = this.item.emp.map(e => e.id).join()
            this.sels = this.item.emp.map(e => e.id)

            this.$http
                .get('/sys/data/user/emp', {
                    params: {
                        size: 10000
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    if (result.code === 0) {
                        this.ctas = result.datas.map(cta => {
                            return {
                                key: cta.id,
                                title: cta.name,
                                chosen: cids.indexOf(cta.id) >= 0
                            }
                        })
                    }
                })
        },
        doSave() {
            this.field.cids = this.sels.join()
            this.$http.post('/cts/ate/device/mgr/cta/set', this.field).then(result => {
                if (result.code === 0) {
                    this.$emit('doLoad')
                    this.$emit('update:show', false)
                    this.$message.success('设置成功')
                }
            })
        }
    }
}
</script>
